import IAppStore from 'app/IAppStore';
import Loading from 'common/ui/Loading';
import TypedSelect from 'common/ui/TypedSelect';
import Address from 'domain/address';
import Country from 'domain/country';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';

export interface AddressEditorProps {
    address: Address;
    setAddress(address: Address): void;
}

const AddressEditor: React.FC<AddressEditorProps> = props => {
    const [countries, setCountries] = useState<Country[]>([]);
    
    const states = useSelector((store: IAppStore) => store.stateProvinces);

    useEffect(() => {
        setCountries(_.uniqBy(states.map(m => m.country), m => m.name));
    }, [states]);

    function isLoaded() {
        return states.length > 0;
    }

    if (!isLoaded) return <Loading />

    return <div>
    <Form as="div">
    <div className="row">
        <div className="col">
            <Form.Group>
                <Form.Label>Line 1</Form.Label>
                <Form.Control
                    type="text"
                    name="line1"
                    value={props.address.line1}
                    onChange={(event: any) => props.setAddress({...props.address, line1: event.target.value})}
                    required
                />
                <Form.Control.Feedback type="invalid">Line 1 is required.</Form.Control.Feedback>
            </Form.Group>
        </div>
        <div className="col">
            <Form.Group>
                <Form.Label className="optional">Line 2</Form.Label>
                <Form.Control
                    type="text"
                    name="line2"
                    value={props.address.line2}
                    onChange={(event: any) => props.setAddress({...props.address, line2: event.target.value})}
                />
            </Form.Group>
        </div>
    </div>
    <div className="row">
        <div className="col">
            <Form.Group>
                <Form.Label>City</Form.Label>
                <Form.Control
                    type="text"
                    name="city"
                    value={props.address.city}
                    onChange={(event: any) => props.setAddress({...props.address, city: event.target.value})}
                    required
                />
                <Form.Control.Feedback type="invalid">City is required.</Form.Control.Feedback>
            </Form.Group>
        </div>
        <div className="col">
            <Form.Group>
                <Form.Label>State/Region</Form.Label>
                <TypedSelect 
                    options={states.filter(s => s.country.name === props.address.country).map(s => s.name)}
                    valueGetter={m => m}
                    textGetter={m => m}
                    value={props.address.region}
                    showNullRow
                    required
                    onValueSelected={val => props.setAddress({...props.address, region: val})}
                />
                <Form.Control.Feedback type="invalid">State/Region is required.</Form.Control.Feedback>
            </Form.Group>
        </div>
    </div>
    <div className="row">
        <div className="col">
            <Form.Group>
                <Form.Label>Country</Form.Label>
                <TypedSelect 
                    options={countries.map(s => s.name)}
                    valueGetter={m => m}
                    textGetter={m => m}
                    value={props.address.country}
                    required
                    onValueSelected={val => props.setAddress({...props.address, country: val})}
                />
            </Form.Group>
        </div> 
        <div className="col">
            <Form.Group>
                <Form.Label>Postal Code</Form.Label>
                <Form.Control
                    type="text"
                    name="postalCode"
                    value={props.address.postalCode}
                    onChange={(event: any) => props.setAddress({...props.address, postalCode: event.target.value})}
                    required
                />
                <Form.Control.Feedback type="invalid">Postal Code is required.</Form.Control.Feedback>
            </Form.Group>
        </div>
    </div>
    </Form>
    </div>
}

export default AddressEditor;